/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountGroupCreateRequest,
  AccountGroupRepresentation,
  AccountGroupUpdateRequest,
  AccountRepresentation,
  AccountingFormulaValidationRequest,
  AccountingFormulaValidationResponse,
  AccountingMetricCreateRequest,
  AccountingMetricRepresentation,
  AccountingMetricUpdateRequest,
  ShareholderRepresentation,
} from '../models/index';
import {
    AccountGroupCreateRequestFromJSON,
    AccountGroupCreateRequestToJSON,
    AccountGroupRepresentationFromJSON,
    AccountGroupRepresentationToJSON,
    AccountGroupUpdateRequestFromJSON,
    AccountGroupUpdateRequestToJSON,
    AccountRepresentationFromJSON,
    AccountRepresentationToJSON,
    AccountingFormulaValidationRequestFromJSON,
    AccountingFormulaValidationRequestToJSON,
    AccountingFormulaValidationResponseFromJSON,
    AccountingFormulaValidationResponseToJSON,
    AccountingMetricCreateRequestFromJSON,
    AccountingMetricCreateRequestToJSON,
    AccountingMetricRepresentationFromJSON,
    AccountingMetricRepresentationToJSON,
    AccountingMetricUpdateRequestFromJSON,
    AccountingMetricUpdateRequestToJSON,
    ShareholderRepresentationFromJSON,
    ShareholderRepresentationToJSON,
} from '../models/index';

export interface CreateAccountGroupRequest {
    accountGroupCreateRequest?: AccountGroupCreateRequest;
}

export interface CreateAccountingMetricRequest {
    groupKey: string;
    accountingMetricCreateRequest?: AccountingMetricCreateRequest;
}

export interface DeleteAccountGroupRequest {
    groupKey: string;
}

export interface DeleteAccountingMetricRequest {
    metricKey: string;
    force?: boolean;
}

export interface GetShareholdersRequest {
    portfolioKey?: string;
}

export interface ParseAccountingFormulaRequest {
    accountingFormulaValidationRequest?: AccountingFormulaValidationRequest;
}

export interface UpdateAccountGroupRequest {
    groupKey: string;
    accountGroupUpdateRequest?: AccountGroupUpdateRequest;
}

export interface UpdateAccountingMetricRequest {
    metricKey: string;
    accountingMetricUpdateRequest?: AccountingMetricUpdateRequest;
}

export interface UploadAccountActivitiesRequest {
    data?: Blob;
    formatHint?: string;
}

export interface UploadGeneratorAssignmentsRequest {
    data?: Blob;
}

/**
 * 
 */
export class AccountingApi extends runtime.BaseAPI {

    /**
     * Create a new account group
     * Create account group
     */
    async createAccountGroupRaw(requestParameters: CreateAccountGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountGroupRepresentation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/accountgroups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountGroupCreateRequestToJSON(requestParameters['accountGroupCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountGroupRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new account group
     * Create account group
     */
    async createAccountGroup(accountGroupCreateRequest?: AccountGroupCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountGroupRepresentation> {
        const response = await this.createAccountGroupRaw({ accountGroupCreateRequest: accountGroupCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new accounting metric
     * Create accounting metric
     */
    async createAccountingMetricRaw(requestParameters: CreateAccountingMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountingMetricRepresentation>> {
        if (requestParameters['groupKey'] == null) {
            throw new runtime.RequiredError(
                'groupKey',
                'Required parameter "groupKey" was null or undefined when calling createAccountingMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/accountgroups/{groupKey}/metrics`;
        urlPath = urlPath.replace(`{${"groupKey"}}`, encodeURIComponent(String(requestParameters['groupKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountingMetricCreateRequestToJSON(requestParameters['accountingMetricCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountingMetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new accounting metric
     * Create accounting metric
     */
    async createAccountingMetric(groupKey: string, accountingMetricCreateRequest?: AccountingMetricCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountingMetricRepresentation> {
        const response = await this.createAccountingMetricRaw({ groupKey: groupKey, accountingMetricCreateRequest: accountingMetricCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete an existing accounting group
     * Delete account group
     */
    async deleteAccountGroupRaw(requestParameters: DeleteAccountGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['groupKey'] == null) {
            throw new runtime.RequiredError(
                'groupKey',
                'Required parameter "groupKey" was null or undefined when calling deleteAccountGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/accountgroups/{groupKey}`;
        urlPath = urlPath.replace(`{${"groupKey"}}`, encodeURIComponent(String(requestParameters['groupKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing accounting group
     * Delete account group
     */
    async deleteAccountGroup(groupKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountGroupRaw({ groupKey: groupKey }, initOverrides);
    }

    /**
     * Delete an existing accounting metric. This is only allowed if the metric is not used or the force flag is set to true
     * Delete accounting metric
     */
    async deleteAccountingMetricRaw(requestParameters: DeleteAccountingMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling deleteAccountingMetric().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['force'] != null) {
            queryParameters['force'] = requestParameters['force'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/metrics/{metricKey}`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing accounting metric. This is only allowed if the metric is not used or the force flag is set to true
     * Delete accounting metric
     */
    async deleteAccountingMetric(metricKey: string, force?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountingMetricRaw({ metricKey: metricKey, force: force }, initOverrides);
    }

    /**
     * Get list of all accounting groups
     * Get account groups
     */
    async getAccountGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountGroupRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/accountgroups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountGroupRepresentationFromJSON));
    }

    /**
     * Get list of all accounting groups
     * Get account groups
     */
    async getAccountGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountGroupRepresentation>> {
        const response = await this.getAccountGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a list of all accounts
     * Get accounts
     */
    async getAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountRepresentationFromJSON));
    }

    /**
     * Get a list of all accounts
     * Get accounts
     */
    async getAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountRepresentation>> {
        const response = await this.getAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a list of all shareholders
     * Get shareholders
     */
    async getShareholdersRaw(requestParameters: GetShareholdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShareholderRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['portfolioKey'] != null) {
            queryParameters['portfolioKey'] = requestParameters['portfolioKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/shareholders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShareholderRepresentationFromJSON));
    }

    /**
     * Get a list of all shareholders
     * Get shareholders
     */
    async getShareholders(portfolioKey?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShareholderRepresentation>> {
        const response = await this.getShareholdersRaw({ portfolioKey: portfolioKey }, initOverrides);
        return await response.value();
    }

    /**
     * Validate a formula
     * Validate formula
     */
    async parseAccountingFormulaRaw(requestParameters: ParseAccountingFormulaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountingFormulaValidationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/formulas/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountingFormulaValidationRequestToJSON(requestParameters['accountingFormulaValidationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountingFormulaValidationResponseFromJSON(jsonValue));
    }

    /**
     * Validate a formula
     * Validate formula
     */
    async parseAccountingFormula(accountingFormulaValidationRequest?: AccountingFormulaValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountingFormulaValidationResponse> {
        const response = await this.parseAccountingFormulaRaw({ accountingFormulaValidationRequest: accountingFormulaValidationRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing accounting group
     * Update account group
     */
    async updateAccountGroupRaw(requestParameters: UpdateAccountGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountGroupRepresentation>> {
        if (requestParameters['groupKey'] == null) {
            throw new runtime.RequiredError(
                'groupKey',
                'Required parameter "groupKey" was null or undefined when calling updateAccountGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/accountgroups/{groupKey}`;
        urlPath = urlPath.replace(`{${"groupKey"}}`, encodeURIComponent(String(requestParameters['groupKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccountGroupUpdateRequestToJSON(requestParameters['accountGroupUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountGroupRepresentationFromJSON(jsonValue));
    }

    /**
     * Update an existing accounting group
     * Update account group
     */
    async updateAccountGroup(groupKey: string, accountGroupUpdateRequest?: AccountGroupUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountGroupRepresentation> {
        const response = await this.updateAccountGroupRaw({ groupKey: groupKey, accountGroupUpdateRequest: accountGroupUpdateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing accounting metric
     * Update accounting metric
     */
    async updateAccountingMetricRaw(requestParameters: UpdateAccountingMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountingMetricRepresentation>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling updateAccountingMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/accounting/metrics/{metricKey}`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccountingMetricUpdateRequestToJSON(requestParameters['accountingMetricUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountingMetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Update an existing accounting metric
     * Update accounting metric
     */
    async updateAccountingMetric(metricKey: string, accountingMetricUpdateRequest?: AccountingMetricUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountingMetricRepresentation> {
        const response = await this.updateAccountingMetricRaw({ metricKey: metricKey, accountingMetricUpdateRequest: accountingMetricUpdateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Upload CSV with account activities
     * Upload account activities
     */
    async uploadAccountActivitiesRaw(requestParameters: UploadAccountActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', requestParameters['data'] as any);
        }

        if (requestParameters['formatHint'] != null) {
            formParams.append('formatHint', requestParameters['formatHint'] as any);
        }


        let urlPath = `/accounting/accounts/activities`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload CSV with account activities
     * Upload account activities
     */
    async uploadAccountActivities(data?: Blob, formatHint?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadAccountActivitiesRaw({ data: data, formatHint: formatHint }, initOverrides);
    }

    /**
     * Upload CSV with generator assignments
     * Upload generator assignments
     */
    async uploadGeneratorAssignmentsRaw(requestParameters: UploadGeneratorAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', requestParameters['data'] as any);
        }


        let urlPath = `/accounting/accounts/generator-assignments`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload CSV with generator assignments
     * Upload generator assignments
     */
    async uploadGeneratorAssignments(data?: Blob, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadGeneratorAssignmentsRaw({ data: data }, initOverrides);
    }

}
